/*  If you're using this component with forms(input)
 *  pass prop 'errorParams' from computed property
 *  to avoid re-render this component after each event
 */

const defaultErrorParams = {
    template: '',
    methods: {},
    data: {},
};

export default {
    name: 'b-message-error',
    template: null,

    props: {
        errorParams: {
            type: Object,
            default: () => ({}),
        },
        container: {
            type: [Boolean, String],
            default: false,
        },
        modifiers: {
            type: Array,
        },
    },

    render(h) {
        return h({
            template: this.errorTemplate,
            methods: this.params.methods,
            data: () => this.params.data,
        });
    },

    computed: {
        params() {
            return Object.assign(defaultErrorParams, this.errorParams);
        },
        innerTemplate() {
            let elementClasses = ['b-message-error'];

            if (this.modifiers) {
                const modifiersList = this.modifiers.map(
                    modifier => `b-message-error__${modifier}`,
                );

                elementClasses = elementClasses.concat(modifiersList);
            }

            return `<div class="${elementClasses.join(
                ' ',
            )}" data-at-role="error_block"><div class="b-message-error_content">${
                this.params.template
            }</div></div>`;
        },
        errorTemplate() {
            if (!this.container) {
                return this.innerTemplate;
            }

            return `<div class="${this.container}">${this.innerTemplate}</div>`;
        },
    },
};
